import { GetHotelBookingQuery } from '@sim-admin-frontends/data-access';
import {
  FormInput,
  FormItemLabel,
  FormSectionHeader,
  SwitchableFormSection,
} from '@sim-admin-frontends/ui-shared';
import { formatTableDateTime } from '@sim-admin-frontends/utils-shared';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import PaymentEditHotelRoom from './PaymentEditHotelRoom';

const SwitchableSectionContentWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spaces.spacing16};
`;

const SwitchableWrapper = styled.div`
  width: 100%;
`;

type Props = {
  hotelBooking?: GetHotelBookingQuery['getHotelBooking'];
};

const PaymentEditHotelBooking = ({ hotelBooking }: Props) => {
  const { t } = useTranslation();
  if (!hotelBooking) {
    return null;
  }

  const { checkinAt, checkoutAt, hotel, rooms, price, showAmountToBeRefunded } = hotelBooking;
  const { showAmount, showCurrencyCode, showServiceFee, showTotalAmount, showWithCommission } =
    price;

  return (
    <>
      <FormSectionHeader title={t('payments.bookingDetails')} />
      <FormInput label={t('payments.hotelId')} value={hotel.id} readOnly disabled />
      <FormInput label={t('payments.hotelName')} value={hotel.name} readOnly disabled />
      <FormInput
        label={t('payments.checkIn')}
        value={formatTableDateTime(checkinAt)}
        readOnly
        disabled
      />
      <FormInput
        label={t('payments.checkoutAt')}
        value={formatTableDateTime(checkoutAt)}
        readOnly
        disabled
      />
      {!!showAmountToBeRefunded && (
        <FormInput
          label={t('payments.amountToBeRefunded')}
          value={showAmountToBeRefunded}
          readOnly
          disabled
        />
      )}
      <SwitchableWrapper>
        <SwitchableFormSection title={t('payments.prices')} initiallyOpened={false}>
          <SwitchableSectionContentWrapper>
            <FormInput label={t('payments.amount')} value={showAmount} readOnly disabled />
            <FormInput label={t('payments.currency')} value={showCurrencyCode} readOnly disabled />
            <FormInput label={t('payments.serviceFee')} value={showServiceFee} readOnly disabled />
            <FormInput
              label={t('payments.amountWithCommission')}
              value={showWithCommission}
              readOnly
              disabled
            />
            <FormInput
              label={t('payments.totalAmount')}
              value={showTotalAmount}
              readOnly
              disabled
            />
            <FormItemLabel>{t('payments.totalAmountDescription')}</FormItemLabel>
          </SwitchableSectionContentWrapper>
        </SwitchableFormSection>
      </SwitchableWrapper>
      <SwitchableWrapper>
        <SwitchableFormSection title={t('payments.rooms')} initiallyOpened={false}>
          <SwitchableSectionContentWrapper>
            {rooms.map((room, index) => (
              <PaymentEditHotelRoom key={room.id} room={room} index={index} />
            ))}
          </SwitchableSectionContentWrapper>
        </SwitchableFormSection>
      </SwitchableWrapper>
    </>
  );
};

export default PaymentEditHotelBooking;
